import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {Format, PhoneService, PrimeNgConfig, RegExpEmail, User, UserType, Validation} from '@app/shared';
import {DirectoryService} from '@app/shared/services/directory.service';


/**
 * @author Jin Chun (Date Aug 2018)
 * @desc display and gather basic user information - used by Consultant/Contractor/Customer/Employee data management
 */
@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css'],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class UserInfoComponent implements OnInit {
  @Input() user: User;                        // user to display and update

  // standard format and validation
  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;
  UserType: typeof UserType = UserType;
  RegExpEmail = RegExpEmail;
  locationsDropDown: SelectItem[];

  constructor(private directoryService: DirectoryService, private phoneService: PhoneService) {
  }

  ngOnInit() {
    this.getLocation();
  }


  getLocation() {
    this.directoryService.getLocationsAsDropdown().subscribe(locations => {
      this.locationsDropDown = locations;
    });
  }

  checkIfUsPhoneNumber(phoneNumber: string) {
    let isUsPhoneNumber = this.phoneService.isUsPhoneNumber(phoneNumber);
    if (!isUsPhoneNumber) {
      this.user.sendSms = false;
    }
    return isUsPhoneNumber;
  }
}
